import React, { useState, useEffect } from "react";
import { useAuth } from "../../../usercontext";
import { getStudentdData } from "../../../lib/scheduledaysview";
import STopMenu from "../../../components/student/topmenu/topmenu";
import { useParams } from "react-router-dom";
import StudentInfoBox from "../studentinfo/studentinfobox";
import StudentTopMenu from "../studentinfo/studenttopmenu";

export default function ParentStudentSchedule() {
  const [scheduleList, setScheduleList] = useState([]);

  const { profile } = useAuth();

  let { slug } = useParams();

  async function GetData() {
    let schlist = await getStudentdData(slug);
    setScheduleList(schlist);
    //console.log("task", schlist);
  }

  useEffect(() => {
    GetData();
  }, []);

  return (
    <>
      {/* <STopMenu slug={slug} activeMenu="ScheduleList" /> */}
      <StudentInfoBox slug={slug} />
      <StudentTopMenu slug={slug} activeMenu={"Schedule"}/>
      <div className="col-12">
        <div className="settings-widget profile-details">
          <div className="settings-inner-blk p-0">
            <div className="profile-heading">
              <h3>Schedule List</h3>
            </div>
            <div className="comman-space pb-0">
              <div className="settings-invoice-blk table-responsive">
                {/* Invoice info */}
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th>Class</th>
                      <th>Date</th>
                      <th>Time</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {scheduleList.map(function (data, ix) {
                      return (
                        <>
                          <tr key={data.id}>
                            <td>{data.class_name}</td>
                            <td>{data.ldate}</td>
                            <td>{data.ltime.substring(0, 5)}</td>
                            <td>
                              {" "}
                              {data.status === "Absent" ? (
                                <span className="badge text-bg-danger">
                                  Absent
                                </span>
                              ) : data.status === "Late" ? (
                                <span className="badge text-bg-warning">
                                  Late
                                </span>
                              ) : data.status === "Present" ? (
                                <span className="badge text-bg-success">
                                  Present
                                </span>
                              ) : (
                                <span className="badge text-bg-light">-</span>
                              )}
                            </td>
                            <td>
                              <a
                                className="btn btn-outline-info"
                                data-bs-toggle="collapse"
                                href={`#collapseExample${data.id}`}
                                role="button"
                                aria-expanded="false"
                                aria-controls={`collapseExample${data.id}`}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="18"
                                  height="18"
                                  fill="currentColor"
                                  className="bi bi-chevron-double-down"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                                  />
                                  <path
                                    fillRule="evenodd"
                                    d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                                  />
                                </svg>
                              </a>
                            </td>
                          </tr>
                          <tr
                            className="collapse"
                            id={`collapseExample${data.id}`}
                            key={ix}
                          >
                            <td
                              colSpan={3}
                              style={{ width: "auto", paddingLeft: "15px" }}
                            >
                              {data.note}
                            </td>
                            <td></td>
                          </tr>
                        </>
                      );
                    })}
                  </tbody>
                </table>
                {/* Invoice info */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
